import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "support"
const SupportIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M11.65 1C7.012 1 3.238 4.774 3.238 9.412v7.764c0 1.07.871 1.942 1.941 1.942s1.942-.871 1.942-1.942v-6.47c0-1.07-.871-1.941-1.942-1.941a1.92 1.92 0 0 0-.62.11c.277-3.674 3.348-6.58 7.091-6.58 3.741 0 6.812 2.903 7.09 6.575a1.906 1.906 0 0 0-.62-.105c-1.07 0-1.94.87-1.94 1.94v6.471c0 1.07.87 1.942 1.94 1.942.229 0 .444-.047.648-.12v.767c0 .357-.291.647-.647.647h-4.649a1.938 1.938 0 0 0-1.822-1.294c-1.07 0-1.941.87-1.941 1.94 0 1.071.87 1.942 1.941 1.942.842 0 1.554-.543 1.822-1.294h4.649c1.07 0 1.94-.87 1.94-1.941V9.412C20.062 4.774 16.289 1 11.65 1Z" />
          <path d="M20.01 10.178v7.526a1.938 1.938 0 0 0 1.294-1.822V12c0-.842-.542-1.554-1.294-1.822ZM3.294 10.178v7.526A1.938 1.938 0 0 1 2 15.882V12c0-.842.543-1.554 1.294-1.822Z" />
        </svg>
      }
    </span>
  )
}
export default SupportIcon
